module.exports = __webpack_public_path__ + "static/media/TOGF_330.a7346269.png";